import { EnvelopeCircleIcon } from "../components/icons/envelopeCircle";
import { FacebookIcon } from "../components/icons/facebook";
import { InstagramIcon } from "../components/icons/instagram";
import { LinkIcon } from "../components/icons/link";
import { PhoneCircleIcon } from "../components/icons/phoneCircle";
import logoLtcaTranspUrl from "@/assets/logo-ltca-academy.png";
import { LinkedinIcon } from "@/components/icons/linkedin";
import { version } from "../../package.json";

export const Contact = (): JSX.Element => {
	return (
		<main className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto">
			<div className="m-5">
				<div className="border-b-[1px] border-dashed border-slate-300 my-4">
					<div className="flex justify-between items-center mb-3">
						<h2 className="text-sm text-slate-400 font-medium">O NAS</h2>
						<img
							alt="LCTA Logo"
							className="h-12 lg:hidden"
							src={logoLtcaTranspUrl}
						/>
					</div>
					<h1 className="font-bold mb-3">
						Akademia LTCA - miejsce dla tych, którzy chcą wiedzieć więcej.
					</h1>
					<p className="font-light mb-3 text-justify">
						To jedna z największych w Polsce platform szkoleniowych z zakresu
						podatków, prawa, prawa pracy, finansów, kompetencji miękkich, AI i
						cyberbezpieczeństwa.
					</p>
				</div>
				<div className="border-b-[1px] border-dashed border-slate-300 my-4">
					<h2 className="text-sm text-slate-400 font-medium pb-3">ADRES</h2>
					<div className="font-light pb-3">ul. Miodowa 1, 00-080 Warszawa</div>
					<h2 className="text-sm text-slate-400 font-medium">EMAIL</h2>
					<div className="flex justify-between items-center">
						<div className="font-light">kontakt@akademialtca.pl</div>
						<a href="mailto:kontakt@akademialtca.pl">
							<EnvelopeCircleIcon />
						</a>
					</div>
					<h2 className="text-sm text-slate-400 font-medium">NUMER TELEFONU</h2>
					<div className="flex justify-between items-center">
						<div className="font-light">+48 575 692 694</div>
						<a href="tel:+48 575 692 694">
							<PhoneCircleIcon />
						</a>
					</div>
					<h2 className="text-sm text-slate-400 font-medium">
						STRONA INTERNETOWA
					</h2>
					<div className="flex justify-between items-center mb-5">
						<div className="font-light">akademialtca.pl</div>
						<a href="https://akademialtca.pl/">
							<LinkIcon />
						</a>
					</div>
				</div>
				<div className="flex justify-items-start items-center gap-10 align-middle">
					<h4>Znajdź nas</h4>
					<a href="https://www.facebook.com/LTCAwydarzenia" target="_blank">
						<FacebookIcon className="inline-block align-middle" />
					</a>
					<a
						href="https://www.instagram.com/explore/locations/676081622599790/akademia-ltca/"
						target="_blank"
					>
						<InstagramIcon />
					</a>
					<a
						href="https://www.linkedin.com/company/akademia-ltca/"
						target="_blank"
					>
						<LinkedinIcon />
					</a>
				</div>
				<div className="flex justify-between items-center mt-6">
					<div className="text-xs text-text2">v {version}</div>
				</div>
			</div>
		</main>
	);
};
